module.exports = __webpack_public_path__ + "20260128d142218t/img/production-pic.2a7c54ea.png";